import React, { useEffect, useState } from "react";
import '../styles/CourseFilter.css'
import Search from "./Search";
import moreIcon from "../images/more-icon.svg";
import FilterSummary from "./FilterSummary";


import { useFetch } from "../hooks/useFetch";
import Skeleton from "@material-ui/lab/Skeleton";
import { useCookies } from "react-cookie";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import { ThemeProvider, createTheme } from "@material-ui/core";

interface CourseFilterProps {
  semesterId: number;
  setSemesterId: any;
  courseId: number;
  setCourseId: any;
  setSearch: any;
  openCreateSemester?: boolean;
  setOpenCreateSemester?: any;
  setOpenAddNewStudents?: any;
}

export default function CourseFilter({ semesterId, setSemesterId, courseId, setCourseId, setSearch, openCreateSemester, setOpenCreateSemester, setOpenAddNewStudents }: CourseFilterProps) {

  const [semesterList, setSemesterList] = useState<any>([])
  const [courseList, setCourseList] = useState<any>([])
  const [totalStudents, setTotalStudents] = useState(0)

  const [cookies, setCookie] = useCookies(['user'])

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const openMoreMenu = Boolean(anchorEl)
  const handleCloseMoreMenu = () => {
    setAnchorEl(null)
  }
  const handleOpenMoreMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const moreMenuTheme = createTheme({
    typography: {
      fontSize: 12,
    },
  })

  const handleSelectCourse = (e: any) => {
    setCourseId(Number(e.target.value))
    localStorage.setItem(`course_id_selected`, e.target.value)
  }

  const handleSelectSemester = (e: any) => {
    const value = e.target.value
    setSemesterId(Number(value))
    localStorage.setItem(`semester_selected`, value)
  }

  const handleOpenCreateSemester = () => {
    setAnchorEl(null)
    setOpenCreateSemester(true)
  }

  const handleOpenAddNewStudents = () => {
    setAnchorEl(null)
    setOpenAddNewStudents(true)
  }

  const { data: getSemestersData, error: getSemestersError, loading: getSemestersLoading } = useFetch({
    url: `/Semesters`,
    method: 'get',
    headers: {
      'Authorization': `Bearer ${cookies?.user?.token}`
    }
  }, openCreateSemester)

  const { data: getCoursesData, error: getCoursesError, loading: getCoursesLoading } = useFetch({
    url: `/Curriculums`,
    method: 'get',
    headers: {
      'Authorization': `Bearer ${cookies?.user?.token}`
    }
  })

  useEffect(() => {
    if (getSemestersData) {
      setSemesterList(getSemestersData)
      if (semesterId === 0 && getSemestersData.length > 0) setSemesterId(getSemestersData[0].id) // If initial id is invalid, set first id as default   
    }
  }, [getSemestersData])

  useEffect(() => {
    if (getCoursesData) {
      setCourseList(getCoursesData)
      if (courseId === 0 && getCoursesData.length > 0) setCourseId(getCoursesData[0].id) // If initial id is invalid, set first id as default   
    }
  }, [getCoursesData])

  return (
    <div className="CourseFilter">
      <div className="CourseFilter-container">
        {(getSemestersLoading || getCoursesLoading) ?
          (
            <div className="CourseFilter-main skeleton">
              <Skeleton variant="text" width={80} height={37.5} />
              <Skeleton variant="text" width={300} height={37.5} />
            </div>
          ) : (
            <div className="CourseFilter-main">
              <div className="CourseFilter-filter">
                <label htmlFor="goals1" className="hide">ภาคที่เข้าศึกษา</label>
                <select name="goals1" id="goals1" className="selector" value={semesterId} onChange={handleSelectSemester} title="ภาคเรียนที่เข้าศึกษา">
                  {semesterList.map(({ id, year, no }: any) => (
                    <option key={id} value={id}>{year + '/' + no}</option>
                  ))}
                </select>
              </div>
              <div className="CourseFilter-filter">
                <label htmlFor="goals2" className="hide">หลักสูตร</label>
                <select name="goals2" id="goals2" className="selector" value={courseId} onChange={handleSelectCourse} title="หลักสูตร">
                  {courseList.map(({ id, curriculumTh, plan, code }: any) => (
                    <option key={id} value={id}>{plan} / {code} /  {curriculumTh}</option>
                  ))}
                </select>
              </div>
              {(totalStudents === 0) &&
                <div className="CourseFilter-filter">
                  <button className="add-new-students" style={{ marginLeft: '.5rem' }} onClick={handleOpenAddNewStudents}>Add New Students</button>
                </div>
              }
              <div className="CourseFilter-filter">
                <ThemeProvider theme={moreMenuTheme}>
                  <Button
                    aria-label="more"
                    aria-controls={openMoreMenu ? 'long-menu' : undefined}
                    aria-expanded={openMoreMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenMoreMenu}
                    style={{ padding: "0.125rem" }}
                  >
                    <img src={moreIcon} alt="" />
                  </Button>
                  <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={openMoreMenu}
                    onClose={handleCloseMoreMenu}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    style={{ marginTop: "2.25rem", marginLeft: "2.25rem" }}
                  >
                    <MenuItem onClick={handleOpenCreateSemester}>Create New Semester</MenuItem>
                    {(totalStudents > 0) && <MenuItem onClick={handleOpenAddNewStudents}>Add New Students</MenuItem>}
                  </Menu>
                </ThemeProvider>
              </div>
            </div>
          )}
        <FilterSummary courseId={courseId} semesterId={semesterId} total={totalStudents} setTotal={setTotalStudents}/>
      </div>
      <div className="CourseFilter-search">
        <Search setSearch={setSearch} />
      </div>
    </div>
  )
}